import { render, staticRenderFns } from "./veJkyMeetKaoqi.vue?vue&type=template&id=063dc23a&scoped=true"
import script from "./veJkyMeetKaoqi.vue?vue&type=script&lang=js"
export * from "./veJkyMeetKaoqi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063dc23a",
  null
  
)

export default component.exports